export default __webpack_public_path__ + "static/media/allEndorsements.186ac968.png";